import { Link } from 'react-router-dom';
import { featuredEvents } from '@/mocks/events';

export default function FeaturedEvents() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门赛事
            </h2>
            <p className="text-foreground-500 text-sm mt-2">实时追踪全球精彩体育赛事</p>
          </div>
          <Link
            to="/category/zuqiu"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {featuredEvents.slice(0, 8).map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.category}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                  {event.league}
                </span>
                {event.status === 'live' && (
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-500">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                    直播中
                  </span>
                )}
                {event.status === 'upcoming' && (
                  <span className="text-xs text-foreground-400">{event.date}</span>
                )}
              </div>
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {event.teams.home}
                </span>
                <span className="text-xs font-bold text-foreground-400 whitespace-nowrap">VS</span>
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {event.teams.away}
                </span>
              </div>
              {event.score && (
                <div className="mt-2 text-center">
                  <span className="text-lg font-heading font-bold text-primary-500">{event.score}</span>
                </div>
              )}
              <div className="mt-2 text-xs text-foreground-400">{event.time}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}